import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedChannel } from '../../../../store/app.selectors';
import { setLoadingChannel } from '../../../shared/store/ui.actions';
import { getChannel, unsetChannel } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'ngx-last-messages-banner',
  templateUrl: './last-messages-banner.component.html',
  styleUrls: ['./last-messages-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LastMessagesBannerComponent {
  private store = inject(Store<AppStateWithChat>);

  selectedChannel = toSignal(this.store.select(selectSelectedChannel), { initialValue: null });

  loadLastMessages(): void {
    const channel = this.selectedChannel();
    if (!channel) {
      return;
    }
    const phoneNumber = channel.phoneNumber;
    const routing = channel.routing;
    const startDateTime = channel.messagesStartDate;
    const tags = channel.messagesTags;
    this.store.dispatch(unsetChannel());
    this.store.dispatch(setLoadingChannel({ value: true }));
    this.store.dispatch(
      getChannel({
        channelUID: null,
        channelByParams: {
          phoneNumber: phoneNumber ?? '',
          routing,
          startDateTime,
          tags,
        },
        autoSelect: true,
        ignoreTags: true,
      })
    );
  }
}
